import React, { useState, useEffect } from 'react'
import {
  Card,
  Button,
  Form,
  Row,
  Col,
  InputGroup,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import {
  BsFunnelFill,
  BsSearch,
  BsArrowClockwise,
  BsCreditCard,
} from 'react-icons/bs'
import {
  LuGraduationCap,
} from 'react-icons/lu'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import axios from 'axios'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Typeahead } from 'react-bootstrap-typeahead'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'

export default function ApplyFees() {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const navigate = useNavigate()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [showFilterCard, setShowFilterCard] = useState(true)
  const [user, setUser] = useState(null)
  const [userRole, setUserRole] = useState([])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  useEffect(() => {
    const userLogged = Cookies.get('user')
    if (userLogged) {
      try {
        setUser(JSON.parse(userLogged))
        setUserRole(JSON.parse(userLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user')
      }
    }
  }, [])

  const { student_id, course_id } = useParams()
  console.log('STUDENT ID: ', student_id)
  // const [feeStructureData, setFeeStructureData] = useState([])
  const [selectedCourse, setSelectedCourse] = useState('')
  const [selectedStudent, setSelectedStudent] = useState('')
  const [selectedFeeStructure, setSelectedFeeStructure] = useState('')
  const [isAcknowledged, setIsAcknowledged] = useState(false)
  const [classes, setClasses] = useState([])
  const [courses, setCourses] = useState([])
  const [students, setStudents] = useState([])
  const [feeStructure, setFeeStructure] = useState([])
  const [currentStudent, setCurrentStudent] = useState(null)
  const [discount, setDiscount] = useState('')
  const [filteredCourse, setFilteredCourse] = useState([])

  useEffect(() => {
    if (course_id) {
      setSelectedCourse(Number(course_id))
    }
  }, [course_id])

  useEffect(() => {
    if (students.length > 0 && student_id) {
      const student = students.find((s) => s.id === parseInt(student_id))
      if (student) {
        setSelectedStudent(student.id)
        setCurrentStudent(student)

        // Also select the corresponding fee structure
        const matchedFees = feeStructure.find(
          (fee) => fee.object_id === student.course_id,
        )
        setSelectedFeeStructure(matchedFees || null)
      }
    }
  }, [students, student_id, feeStructure])

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => {
      console.log('📌 All Courses:', res.data.data)
      setCourses(res.data.data)
    })

    // ApiEndpoints.getAllStudents().then((res) => {
    //   console.log('📌 All Students:', res.data.data)
    //   setStudents(res.data.data)
    // })
    ApiEndpoints.getAllFees().then((res) => {
      console.log('📌 All Fee Structure:', res.data.data)
      setFeeStructure(res.data.data)
    })
    ApiEndpoints.getAllClasses().then((res) => {
      console.log('📌 All classes:', res.data.data)
      setClasses(res.data.data)
    })
  }, [])

  useEffect(() => {
    if (
      student_id &&
      students.length > 0 &&
      course_id &&
      courses.length > 0 &&
      feeStructure.length > 0
    ) {
      const student = students.find((s) => s.id === parseInt(student_id))
      if (student) {
        setSelectedStudent(student.id)
        setCurrentStudent(student)
        setSelectedCourse(student.course_id)

        const matchedFees = feeStructure.filter(
          (fee) => fee.object_id === student.course_id,
        )
        setSelectedFeeStructure(matchedFees[0] || null)
      }
    }
  }, [student_id, course_id, students, feeStructure])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      if (!selectedCourse) return
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+`/get/student/by-course?course_id=${selectedCourse}`,
          { headers },
        )

        console.log('Students response: ', response.data.data)

        // setData(response.data.data)
        setStudents(response.data.data)
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [selectedCourse])

  // Handle Course Selection

  const handleCourseChange = (e) => {
    const courseId = parseInt(e.target.value)
    setSelectedCourse(courseId)
    setSelectedFeeStructure('')
    setSelectedStudent('')

    console.log('✅ Selected Course ID:', courseId)
    console.log('📌 All Student Before Filtering:', students)
    console.log('📌 All Fee Structure Before Filtering:', feeStructure)
    const matchedFees = feeStructure.filter((fee) => fee.object_id === courseId)
    console.log('📌 Filtered Fee Structure:', matchedFees)

    setSelectedFeeStructure(matchedFees || null)
  }

  const handleFeeStructure = (e) => {
    const feeId = parseInt(e.target.value)
    console.log('✅ Selected Fee Structure ID:', feeId)

    const selectedFee = feeStructure.find((fee) => fee.id === feeId)

    setSelectedFeeStructure(selectedFee || null)
    console.log('✅ Selected Fee Structure:', selectedFee)
  }

  // Handle Student Selection
  const handleStudentChange = (e) => {
    setSelectedStudent(parseInt(e.target.value))
    console.log('✅ Selected Student ID:', e.target.value)
  }
  // const isOneTimeFee = () => {
  //   const name = selectedFeeStructure?.fee_name?.toLowerCase()
  //   return name === 'admission' || name === 'registration'
  // }

  const handleSave = async () => {
    if (!selectedStudent || !selectedFeeStructure) {
      toast.error('Please select both Student and Fee Structure.')
      return
    }

    if (Number(discount) > Number(selectedFeeStructure?.amount)) {
      toast.error('Discount cannot be greater than fee amount.')
      return
    }

    const requestData = {
      student_id: selectedStudent, // Correct Student ID
      fee_structure_id: selectedFeeStructure.id,
      discount: discount || '0',
    }

    console.log('🔹 Sending Data: ', requestData)

  // const userCookie = Cookies.get('user')
  // const instituteId = Cookies.get('institute_id')
  // let token = null

  // if (userCookie) {
  //   try {
  //     const user = JSON.parse(userCookie)
  //     token = user.token
  //   } catch (err) {
  //     console.error('Failed to parse user cookie', err)
  //   }
  // }

  // const headers = {
  //   'Content-Type': 'application/json',
  //   Authorization: `Bearer ${token}`,
  //   'institute-Id': Number(instituteId),
  // }
  //   console.log('🔹 Headers: ', headers)


    try {
      const response = await ApiEndpoints.addStudentApplyFees(requestData
        // , headers

      )
      console.log('✅ Applied Successfully:', response)
      toast.success('Fee applied successfully!')
      handleRefresh()
    } catch (error) {
      console.error('❌ Error Applying Fee:', error.response?.data)
      toast.error(error.response?.data?.result || 'Failed to apply fee.')
    }
  }

  const handleRefresh = () => {
    // Reset selected values to initial state
    setSelectedCourse('')
    setSelectedFeeStructure(null)
    setSelectedStudent('')
    // Reset filtered course data to the original courses list
    setFilteredCourse(courses)
    setCurrentStudent(null)
    navigate('/ApplyFees')
  }

  return (
    <>
      <style>
        {`
          /* Fix Typeahead dropdown visibility - ensure it appears above filter card */
          .rbt-menu {
            z-index: 1051 !important;
            max-height: 300px !important;
            overflow-y: auto !important;
            position: absolute !important;
            width: 100% !important;
            background-color: #ffffff !important;
            border: 1px solid #D1D3D4 !important;
            border-radius: 8px !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
            margin-top: 4px !important;
          }
          
          .rbt-input-wrapper {
            position: relative !important;
            z-index: 1 !important;
          }
          
          .rbt-input-main {
            border-radius: 8px !important;
            border: 1px solid #D1D3D4 !important;
            font-size: 14px !important;
            padding: 8px 12px !important;
            transition: all 0.2s ease !important;
            font-family: 'Inter', system-ui, sans-serif !important;
          }
          
          .rbt-input-main:focus {
            border-color: #223843 !important;
            outline: none !important;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
          }
          
          .rbt-menu .dropdown-item {
            padding: 10px 12px !important;
            font-size: 14px !important;
            font-family: 'Inter', system-ui, sans-serif !important;
            color: #111827 !important;
            cursor: pointer !important;
          }
          
          .rbt-menu .dropdown-item:hover,
          .rbt-menu .dropdown-item.active {
            background-color: #F3F4F6 !important;
            color: #111827 !important;
          }
          
          /* Ensure filter card container allows dropdown to overflow */
          .filter-card-container {
            overflow: visible !important;
            position: relative !important;
            z-index: 10 !important;
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%',
            }}
          >
            {/* Left: Title */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0,
              }}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif',
                }}
              >
                Apply Fees{currentStudent && ` for ${currentStudent.name}`}
              </h3>
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && (
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px',
          }}
        >
          {/* Filter Toggle Button */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-3">
              <button
                onClick={() => setShowFilterCard(!showFilterCard)}
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: showFilterCard ? '#ffffff' : '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.color = '#ffffff'
                  e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                  e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
              >
                <BsFunnelFill size={20} />
              </button>
            </div>
          </div>

          {/* Modern Filter Section */}
          <div 
            className="filter-card-container"
            style={{
              maxHeight: showFilterCard ? '1000px' : '0',
              overflow: showFilterCard ? 'visible' : 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              marginBottom: showFilterCard ? '24px' : '0',
              position: 'relative',
              zIndex: showFilterCard ? 10 : 1,
            }}
          >
            {showFilterCard && (
              <Card 
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  overflow: 'visible',
                  position: 'relative',
                }}
              >
                {/* Header */}
                <div 
                  style={{
                    background: '#ffffff',
                    padding: '20px',
                    borderBottom: '1px solid #F3F4F6',
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                      <div 
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                      </div>
                      <div>
                        <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Select Course, Fee Structure & Student
                        </h5>
                        <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                          Choose course, fee structure and student to apply fees
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        onClick={handleRefresh}
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Refresh"
                      >
                        <BsArrowClockwise size={20} />
                      </button>
                    </div>
                  </div>
                </div>

                <Card.Body className="p-4" style={{ backgroundColor: '#ffffff', overflow: 'visible', position: 'relative' }}>
                  <Row className="g-4 text-start">
                    {/* Course Selection */}
                    <Col xs={12} md={4}>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#F3F4F6', 
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4',
                        overflow: 'visible',
                        position: 'relative',
                      }}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <div 
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                          </div>
                          <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Select Course
                          </label>
                        </div>
                        <div style={{ position: 'relative', zIndex: 1050 }}>
                          <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Course
                          </label>
                          <div style={{ position: 'relative', zIndex: 1050 }}>
                            <Typeahead
                              id="course-select"
                              labelKey="name"
                              onChange={(selected) => {
                                const course = selected[0]
                                if (course) {
                                  handleCourseChange({ target: { value: course.id } })
                                } else {
                                  handleCourseChange({ target: { value: '' } })
                                }
                              }}
                              options={courses}
                              placeholder="Select Course"
                              selected={selectedCourse ? courses.filter(
                                (cs) => cs.id === Number(selectedCourse),
                              ) : []}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>

                    {/* Fee Structure Selection */}
                    <Col xs={12} md={4}>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#F3F4F6', 
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4',
                        overflow: 'visible',
                        position: 'relative',
                      }}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <div 
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <BsCreditCard style={{ color: '#ffffff', fontSize: '16px' }} />
                          </div>
                          <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Select Fee Structure
                          </label>
                        </div>
                        <div style={{ position: 'relative', zIndex: 1050 }}>
                          <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Fee Structure
                          </label>
                          <div style={{ position: 'relative', zIndex: 1050 }}>
                            <Typeahead
                              id="fee-structure-select"
                              labelKey={(option) => {
                                const name = option.fee_name
                                  ? option.fee_name.charAt(0).toUpperCase() +
                                    option.fee_name.slice(1)
                                  : 'N/A'
                                const freq = option.fee_frequency
                                  ? ` (${option.fee_frequency})`
                                  : ''
                                return `₹ ${option.amount} - ${name}${freq}`
                              }}
                              onChange={(selected) => {
                                const fee = selected[0]
                                if (fee) {
                                  handleFeeStructure({ target: { value: fee.id } })
                                } else {
                                  handleFeeStructure({ target: { value: '' } })
                                }
                              }}
                              options={feeStructure.filter(
                                (fee) => fee.object_id === selectedCourse,
                              )}
                              placeholder="Select Fee Structure"
                              selected={
                                selectedFeeStructure
                                  ? feeStructure.filter(
                                      (fee) => fee.id === selectedFeeStructure.id,
                                    )
                                  : []
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Col>

                    {/* Student Selection */}
                    <Col xs={12} md={4}>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#F3F4F6', 
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4',
                        overflow: 'visible',
                        position: 'relative',
                      }}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <div 
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                          </div>
                          <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Select Student
                          </label>
                        </div>
                        <div style={{ position: 'relative', zIndex: 1050 }}>
                          <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Student
                          </label>
                          <div style={{ position: 'relative', zIndex: 1050 }}>
                            <Typeahead
                              id="student-select"
                              labelKey={(option) =>
                                `${option.name} - ${option.admission_number}`
                              }
                              onChange={(selected) => {
                                const student = selected[0]
                                if (student) {
                                  handleStudentChange({ target: { value: student.id } })
                                } else {
                                  handleStudentChange({ target: { value: '' } })
                                }
                              }}
                              options={students}
                              placeholder="Select Student"
                              selected={selectedStudent ? students.filter(
                                (st) => st.id === Number(selectedStudent),
                              ) : []}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
          </div>
          {/* Fee Details Form */}
          <Card 
            style={{
              border: '1px solid #D1D3D4',
              borderRadius: '12px',
              backgroundColor: '#ffffff',
              overflow: 'hidden',
            }}
          >
            <Card.Body className="p-4 text-start">
              <Row>
                <Col md={6}>
                  <Form.Group controlId="studentId" className="mb-3">
                    <Form.Label className="fw-semibold" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                      Fee Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={
                        selectedFeeStructure ? selectedFeeStructure.fee_name : ''
                      }
                      disabled
                      style={{
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4',
                        fontSize: '14px',
                        padding: '10px 12px',
                        backgroundColor: '#F3F4F6',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="courseId" className="mb-3">
                    <Form.Label className="fw-semibold" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>Amount</Form.Label>
                    <Form.Control
                      type="text"
                      value={
                        selectedFeeStructure
                          ? !selectedFeeStructure.amount
                            ? '₹ 0'
                            : `₹ ${selectedFeeStructure.amount}`
                          : ''
                      }
                      disabled
                      style={{
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4',
                        fontSize: '14px',
                        padding: '10px 12px',
                        backgroundColor: '#F3F4F6',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="fw-semibold" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                      Frequency
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={
                        selectedFeeStructure
                          ? selectedFeeStructure.fee_frequency
                          : ''
                      }
                      disabled
                      style={{
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4',
                        fontSize: '14px',
                        padding: '10px 12px',
                        backgroundColor: '#F3F4F6',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="courseId" className="mb-3">
                    <Form.Label className="fw-semibold" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>From</Form.Label>
                    <Form.Control
                      type="text"
                      value={
                        selectedStudent
                          ? (() => {
                              const student = students.find(
                                (s) => s.id === selectedStudent,
                              )
                              const classData = classes.find(
                                (c) => c.id === student?.class_id,
                              )
                              return classData?.start_date
                                ? new Date(
                                    classData.start_date,
                                  ).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: 'long',
                                    year: 'numeric',
                                  })
                                : 'N/A'
                            })()
                          : ''
                      }
                      disabled
                      style={{
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4',
                        fontSize: '14px',
                        padding: '10px 12px',
                        backgroundColor: '#F3F4F6',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="" className="mb-3">
                    <Form.Label className="fw-semibold" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>To</Form.Label>
                    <Form.Control
                      type="text"
                      value={
                        selectedStudent
                          ? (() => {
                              const student = students.find(
                                (s) => s.id === selectedStudent,
                              )
                              const classData = classes.find(
                                (c) => c.id === student?.class_id,
                              )
                              return classData?.end_date
                                ? new Date(
                                    classData.end_date,
                                  ).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: 'long',
                                    year: 'numeric',
                                  })
                                : 'N/A'
                            })()
                          : ''
                      }
                      disabled
                      style={{
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4',
                        fontSize: '14px',
                        padding: '10px 12px',
                        backgroundColor: '#F3F4F6',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>Discount</Form.Label>
                    <InputGroup>
                      <InputGroup.Text style={{
                        borderRadius: '8px 0 0 8px',
                        border: '1px solid #D1D3D4',
                        backgroundColor: '#F3F4F6',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}>₹</InputGroup.Text>
                      <Form.Control
                        type="number"
                        id="discount"
                        value={discount}
                        onChange={(e) => setDiscount(e.target.value)}
                        placeholder="Enter discount"
                        style={{
                          borderRadius: '0 8px 8px 0',
                          border: '1px solid #D1D3D4',
                          fontSize: '14px',
                          padding: '10px 12px',
                          transition: 'all 0.2s ease',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#223843'
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#D1D3D4'
                        }}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Check
                      className="text-danger"
                      type="checkbox"
                      id="acknowledgeCheckbox"
                      label="I acknowledge and agree that this process is irreversible and cannot be undone."
                      checked={isAcknowledged}
                      onChange={(e) => setIsAcknowledged(e.target.checked)}
                      style={{
                        fontSize: '14px',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Apply Button */}
              <div className="d-grid mt-4">
                <Button
                  variant="success"
                  className="fw-semibold"
                  onClick={handleSave}
                  disabled={!isAcknowledged}
                  style={{
                    borderRadius: '8px',
                    padding: '12px 24px',
                    fontSize: '16px',
                    fontFamily: 'Inter, system-ui, sans-serif',
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={(e) => {
                    if (!isAcknowledged) return
                    e.currentTarget.style.transform = 'scale(1.02)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                >
                  Apply Fees
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  )
}
